/** @file useThumbnail: a filled slot's tile from the preview bundle as a data URL (null until ready). */
import { useEffect, useState } from 'react';
import type { LoadedBundle } from '@zilo/pose3d-runtime-babylon/bundle/loadedBundle';
import { imageDataUrl } from './imageDataUrl';
import { thumbnailOf } from './thumbnailOf';

/** `thumbnailOf(bundle, slot)` encoded as a data URL; recomputed when the bundle or the slot changes. */
export function useThumbnail(bundle: LoadedBundle | null, slot: { drawable: string; entry: number; tile: number }): string | null {
  const [url, setUrl] = useState<string | null>(null);
  const { drawable, entry, tile } = slot;
  useEffect(() => {
    const image = thumbnailOf(bundle, { drawable, entry, tile });
    if (image === null) {
      setUrl(null);
      return undefined;
    }
    let live = true;
    void imageDataUrl(image).then((u) => { if (live) setUrl(u); });
    return () => { live = false; };
  }, [bundle, drawable, entry, tile]);
  return url;
}
